import * as React from 'react';
import { connect } from 'react-redux';

import { getOverlayVisibility } from '../reducers/gui';

import { overlayToggle } from '../actions/overlay';

import StatsControls from './StatsControls';

import VideoOverlayPresentation from '../presentations/VideoOverlay/VideoOverlayPresentation';

const mapStateToProps = (state:any) => ({
    // prop: value...
    visible: getOverlayVisibility(state)
});

export default connect(mapStateToProps)(VideoOverlayPresentation);
